export const DASHBOARD_RTO_TOP_RTO_ACTION="DASHBOARD_RTO_TOP_RTO_ACTION"
export const DASHBOARD_RTO_TOP_CITY_ACTION="DASHBOARD_RTO_TOP_CITY_ACTION"
export const DASHBOARD_RTO_COUNT_MONTHWISE_ACTION="DASHBOARD_RTO_COUNT_MONTHWISE_ACTION"
export const DASHBOARD_RTO_TOP_COURIER_ACTION="DASHBOARD_RTO_TOP_COURIER_ACTION"
export const DASHBOARD_RTO_STATUS_ACTION="DASHBOARD_RTO_STATUS_ACTION"